<template>
    <div class="lib-accordion-category">
        <div class="lib-accordion-category-header" @click="manuallyExpanded = !manuallyExpanded">
            <span v-if="expanded" class="fa fa-caret-down"></span>
            <span v-else class="fa fa-caret-right"></span>
            <slot name="header">
            </slot>
        </div>
        <div v-if="expanded" class="lib-accordion-items">
            <div
                v-for="item in children"
                class="lib-accordion-item"
                :class="{_disabled: isDisabled && isDisabled(item)}"
                @click="$emit('clicked', item)">
                <template v-if="isSelected">
                    <div class="lib-checkbox">
                        <input type="checkbox" :checked="isSelected(item)">
                        <span class="lib-checkbox-visual"></span>
                    </div>
                </template>
                <slot :item="item">
                    {{item}}
                </slot>
                <div class="lib-accordion-action">
                    <slot name="action"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LibAccordionCategory',
    components: {},
    props: ['children', 'forceExpand', 'initiallyExpanded', 'isSelected', 'isDisabled'],
    data: function() {
        return {
            manuallyExpanded: !!this.initiallyExpanded,
        };
    },
    computed: {
        expanded() {
            return this.manuallyExpanded || this.forceExpand;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../styles/prelude";

.lib-accordion-category-header {
    display: flex;
    align-items: center;
    position: relative;
    background-color: $lightgray;
    padding: 8px 8px 8px 16px;

    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.95px;
    text-transform: uppercase;

    .fa {
        display: inline-block;
        width: 8px;
        text-align: center;
        margin-right: 10px;
    }

    &:hover {
        cursor: pointer;
        background-color: $gray;
    }
}

.lib-accordion-items {
    .lib-accordion-item {
        color: $navy;
        position: relative;
        display: flex;
        align-items: center;
        padding: 10px 12px 10px 34px;
        font-weight: 500;
        font-family: Lato, sans-serif;
        font-size: 18px;
        line-height: 18px;

        .lib-checkbox-visual {
            position: absolute;
            top: 11px;
            left: 12px;
        }

        .lib-accordion-action {
            display: none;
            font-size: 10px;
            font-weight: bold;
            letter-spacing: 1.5px;
            text-transform: uppercase;

            .fa {
                font-size: 14px;
            }
        }

        &:not(._disabled):hover {
            cursor: pointer;
            color: $white;
            background-color: $bluegray;

            .lib-accordion-action {
                display: block;
                position: absolute;
                right: 40px;
                top: 12px;
            }
        }

        &._disabled {
            opacity: 0.5;
            cursor: default;

            &:hover {
                color: $navy;
            }
        }
    }
}
</style>